/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitFindingTemplate
 */
export interface MonitFindingTemplate {
    /**
     * 
     * @type {string}
     * @memberof MonitFindingTemplate
     */
    template_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitFindingTemplate
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitFindingTemplate
     */
    risk?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitFindingTemplate
     */
    recommendation?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitFindingTemplate
     */
    references?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitFindingTemplate
     */
    level?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitFindingTemplate
     */
    tags?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MonitFindingTemplate
     */
    score_category?: string;
}

/**
 * Check if a given object implements the MonitFindingTemplate interface.
 */
export function instanceOfMonitFindingTemplate(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitFindingTemplateFromJSON(json: any): MonitFindingTemplate {
    return MonitFindingTemplateFromJSONTyped(json, false);
}

export function MonitFindingTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitFindingTemplate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'template_id': !exists(json, 'template_id') ? undefined : json['template_id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'risk': !exists(json, 'risk') ? undefined : json['risk'],
        'recommendation': !exists(json, 'recommendation') ? undefined : json['recommendation'],
        'references': !exists(json, 'references') ? undefined : json['references'],
        'level': !exists(json, 'level') ? undefined : json['level'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'score_category': !exists(json, 'score_category') ? undefined : json['score_category'],
    };
}

export function MonitFindingTemplateToJSON(value?: MonitFindingTemplate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'template_id': value.template_id,
        'title': value.title,
        'risk': value.risk,
        'recommendation': value.recommendation,
        'references': value.references,
        'level': value.level,
        'tags': value.tags,
        'score_category': value.score_category,
    };
}

